export const changelogEntryRefName = 'changelogEntryRef';

export const changelogEntryRefProjection = `{
  ...,
}`;

export const changelogEntryRefQuery = groq`*[_id == $_id][0] ${changelogEntryRefProjection}`;
